export default "__VITE_ASSET__CfMA1nah__"